import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./Careers.css";
import { Link } from "react-router-dom";

import { useEffect } from "react";

function Careers() {
    const calendarLink = "https://calendar.app.google/7nGDpZfAhM9ic7tg6";

  const testimonials = [
    {
      id: 1,
      quote:
        "Kubera Financial Services gave me the training, support, and tools I needed to build a six-figure business. The team truly wants you to win!",
      name: "Ramesh K.",
      title: "Licensed Agent",
    },
    {
      id: 2,
      quote:
        "Working with Kubera has transformed my career. The resources and mentorship available are unmatched in the industry.",
      name: "Sarah M.",
      title: "Senior Insurance Agent",
    },
    {
      id: 3,
      quote:
        "I started as a complete beginner, and Kubera provided everything I needed to get licensed and build a thriving practice.",
      name: "James T.",
      title: "New Licensed Agent",
    },
    {
      id: 4,
      quote:
        "The flexibility and earning potential here far exceed what I experienced at other organizations. Truly grateful for the opportunity.",
      name: "Michelle R.",
      title: "Independent Agent",
    },
    {
      id: 5,
      quote:
        "The support system at Kubera is incredible. They genuinely invest in your success and provide continuous training and guidance.",
      name: "David P.",
      title: "Regional Manager",
    },
  ];

  useEffect(() => {
    if (window.Swiper) {
      new window.Swiper(".tp-testimonial-careers-slider", {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: false,
        pagination: {
          el: ".tp-testimonial-careers-pagination",
          clickable: true,
        },
        loop: true,
        effect: "slide",
        speed: 500,
      });
    }
  }, []);

  return (
    <>
      <Header />

      <main>
        <section className="tp-hero-area p-relative">
          <div className="tp-hero-wrapper-slider">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                <div
                  className="swiper-slide career-header"
                  data-bg-color="#1a2749"
                >
                  {/* <img class="tp-hero-bg" src="../assets/images/banner-bg.png"/> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="career-background">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-12 mt-80">
                <h4>CAREERS</h4>
                <h1>
                  Build a Career with Purpose.
                  <br />
                  <span> Grow Without Limits.</span>
                </h1>
                <p>
                  Join Kubera Financial Services and take control of your future
                  in Life & Health Insurance.
                </p>
                <div className="tp-build-future-buttons d-flex justify-content-start gap-20 pt-15">
                    <Link to="/ContactUs" className="tp-btn tp-btn-primary">
                      <i className="fa-regular fa-user-check"></i>
                      Apply Now
                    </Link>
                    <a
                      href={calendarLink}
                      target="_blank"
                      className="tp-btn tp-btn-outline"
                    >
                      <i className="fa-regular fa-calendar-check"></i>
                      Schedule a Call
                    </a>
                  </div>
              </div>
            </div>
          </div>
        </section>
        {/* We're Actively Recruiting Section */}
        <section
          className="tp-about-area p-relative mt-50"
          data-bg-color="#fff"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="tp-service-title-wrapper mb-60">
                      <span className="tp-section-tag">
                        WE'RE ACTIVELY RECRUITING
                      </span>
                      <h2 className="tp-section-title">
                        Opportunities for Every Stage of Your Career
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 mb-20">
                        <div className="tp-career-card">
                          <div className="tp-career-card-icon">
                            <i className="fa-regular fa-user-tie"></i>
                          </div>
                          <h4 className="tp-career-card-title">
                            Experienced Licensed Agents
                          </h4>
                          <p>
                            Take your career to the next level with better
                            support and higher earning potential.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 mb-20">
                        <div className="tp-career-card">
                          <div className="tp-career-card-icon">
                            <i className="fa-regular fa-medal"></i>
                          </div>
                          <h4 className="tp-career-card-title">
                            Newly Licensed Agents
                          </h4>
                          <p>
                            Get the guidance, training, and tools you need to
                            build a successful business.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 mb-20">
                        <div className="tp-career-card">
                          <div className="tp-career-card-icon">
                            <i className="fa-regular fa-graduation-cap"></i>
                          </div>
                          <h4 className="tp-career-card-title">
                            Entry-Level Candidates
                          </h4>
                          <p>
                            No license yet? No problem. We provide training to
                            help you get licensed and started.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 mb-20">
                        <div className="tp-career-card">
                          <div className="tp-career-card-icon">
                            <i className="fa-regular fa-clock"></i>
                          </div>
                          <h4 className="tp-career-card-title">
                            Part-Time & Full-Time
                          </h4>
                          <p>
                            Flexible opportunities that fit your lifestyle and
                            goals.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-12">
                <section className="tp-career-network" data-bg-color="#1a2749">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 mb-40">
                      <div className="tp-network-content">
                        <span
                          className="tp-section-tag"
                          style={{ color: "#d4a574" }}
                        >
                          OUR NETWORK & PARTNERSHIPS
                        </span>
                        <h3
                          className="tp-section-title"
                          style={{ color: "#fff" }}
                        >
                          Affiliated with One of America's Fastest-Growing IMOs
                        </h3>
                        <p style={{ color: "#fff", marginTop: "20px" }}>
                          Kubera Financial Services is affiliated with one of
                          America's fastest-growing Insurance Marketing
                          Organizations (IMO).
                        </p>
                        <p style={{ color: "#fff", marginTop: "15px" }}>
                          This partnership gives our agents access to top-tier
                          carriers, advanced training systems, and
                          industry-leading support — helping you grow faster and
                          serve clients better.
                        </p>
                        <p
                          style={{
                            color: "#d4a574",
                            marginTop: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          ACCESS TO 20+ TOP INSURANCE CARRIERS
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>

        {/* Why Join Section */}
        <section
          className="tp-why-join-area p-relative mt-30"
          data-bg-color="#fff"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="tp-service-title-wrapper text-center mb-60">
                  <span className="tp-section-tag">WHY JOIN</span>
                  <h2 className="tp-section-title">
                    Why Join Kubera Financial Services?
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-dollar-sign"></i>
                  </div>
                  <h4 className="tp-why-join-title">
                    Competitive Commissions & Bonuses
                  </h4>
                  <p>Earn what you're worth. Your success is our success.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-chart-line"></i>
                  </div>
                  <h4 className="tp-why-join-title">
                    Unlimited Growth Potential
                  </h4>
                  <p>Build your business your way with no income ceiling.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-graduation-cap"></i>
                  </div>
                  <h4 className="tp-why-join-title">Training & Mentorship</h4>
                  <p>
                    Comprehensive training, ongoing coaching, and mentorship.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-calendar"></i>
                  </div>
                  <h4 className="tp-why-join-title">Flexible Work Schedule</h4>
                  <p>
                    Create the lifestyle you want with a schedule that works for
                    you.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-shield-check"></i>
                  </div>
                  <h4 className="tp-why-join-title">Top Insurance Carriers</h4>
                  <p>Access to 20+ A-rated carriers and innovative products.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div className="tp-why-join-item">
                  <div className="tp-why-join-icon">
                    <i className="fa-regular fa-handshake"></i>
                  </div>
                  <h4 className="tp-why-join-title">Supportive Team</h4>
                  <p>
                    You're never alone. We support you every step of the way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Roles & Opportunities Section */}
        <section
          className="tp-roles-area p-relative pt-50 pb-50"
          data-bg-color="#1a2749"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-12 tp-role-container">
                <h4 className="tp-effort-title">ROLES & OPPORTUNITIES</h4>
                <div className="tp-role-item">
                  <div className="tp-role-icon">
                    <i className="fa-regular fa-briefcase"></i>
                  </div>
                  <div className="tp-role-content">
                    <h4 className="tp-role-title">Insurance Sales Agent</h4>
                    <p>
                      Help individuals and families protect their future by
                      offering life, health, and annuity solutions.
                    </p>
                  </div>
                </div>
                <hr />
                <div className="tp-role-item">
                  <div className="tp-role-icon">
                    <i className="fa-regular fa-user-circle"></i>
                  </div>
                  <div className="tp-role-content">
                    <h4 className="tp-role-title">Independent Agent</h4>
                    <p>
                      Build your own book of business with the freedom,
                      flexibility, and support you need to thrive.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 tp-effort-container">
                <h4 className="tp-effort-title">YOUR EFFORT = YOUR INCOME</h4>
                <h3>Uncapped Earning Potential</h3>
                <div className="tp-effort-list mt-30">
                  <div className="tp-effort-item">
                    <i className="fa-regular fa-check"></i>
                    <span>Commission-Based Earnings</span>
                  </div>
                  <div className="tp-effort-item">
                    <i className="fa-regular fa-check"></i>
                    <span>Performance Bonuses</span>
                  </div>
                  <div className="tp-effort-item">
                    <i className="fa-regular fa-check"></i>
                    <span>Renewal & Residual Income</span>
                  </div>
                  <div className="tp-effort-item">
                    <i className="fa-regular fa-check"></i>
                    <span>Leadership & Override Opportunities</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <h4 className="tp-effort-title">WHAT OUR AGENTS SAY</h4>
                <div className="swiper-container tp-testimonial-careers-slider">
                  <div className="swiper-wrapper">
                    {testimonials.map((testimonial) => (
                      <div
                        className="swiper-slide tp-testimonial-careers-item mt-30"
                        key={testimonial.id}
                      >
                        <p>"{testimonial.quote}"</p>
                        <div className="tp-testimonial-careers-author d-flex mt-20">
                          <div className="tp-testimonial-careers-avatar">
                            <i className="fa-regular fa-user-tie"></i>
                          </div>
                          <div className="tp-testimonial-careers-info">
                            <h6 className="tp-testimonial-careers-name">
                              - {testimonial.name}
                            </h6>
                            <span className="tp-testimonial-careers-title">
                              {testimonial.title}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="swiper-pagination tp-testimonial-careers-pagination" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Let's build your future section */}
        <section
          className="tp-build-future-area p-relative pt-80 pb-80"
          data-bg-color="#f5f5f5"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="tp-build-future-wrapper text-center">
                  <span className="tp-section-tag">
                    READY TO START YOUR JOURNEY?
                  </span>
                  <h2 className="tp-section-title mt-20 mb-30">
                    Let's Build Your Future Together
                  </h2>
                  <p className="tp-build-future-description mb-40">
                    Apply today to join Kubera Financial Services and be part of
                    a team that's changing lives and building legacies.
                  </p>

                  <div className="tp-build-future-contact d-flex justify-content-center align-items-center gap-40 mb-40">
                    <div className="tp-contact-item d-flex align-items-center gap-10">
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:+18131234567">(813) 123-4567</a>
                    </div>
                    <div className="tp-contact-item d-flex align-items-center gap-10">
                      <i className="fa-solid fa-envelope"></i>
                      <a href="mailto:getrich@kuberafinancialservices.com">
                        getrich@kuberafinancialservices.com
                      </a>
                    </div>
                  </div>

                  <div className="tp-build-future-buttons d-flex justify-content-center align-items-center gap-20">
                    <Link to="/ContactUs" className="tp-btn tp-btn-primary">
                      <i className="fa-regular fa-user-check"></i>
                      Apply Now
                    </Link>
                    <a
                      href={calendarLink}
                      target="_blank"
                      className="tp-btn tp-btn-outline"
                    >
                      <i className="fa-regular fa-calendar-check"></i>
                      Schedule a Call
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default Careers;
